var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app flex-row align-items-center" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _vm.resetPassword
              ? _c(
                  "b-modal",
                  {
                    staticClass: "aligned",
                    attrs: { title: "Reset Password", "hide-footer": "" },
                    on: {
                      ok: function ($event) {
                        _vm.resetPassword = false
                      },
                    },
                    model: {
                      value: _vm.resetPassword,
                      callback: function ($$v) {
                        _vm.resetPassword = $$v
                      },
                      expression: "resetPassword",
                    },
                  },
                  [
                    _c("p", [_vm._v("We have sent an email to:")]),
                    _vm._v(" "),
                    _c("p", [_c("b", [_vm._v(_vm._s(_vm.username))])]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Please use the link in the email to reset the password."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.done.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary login center-block modalSubmit",
                            attrs: { id: "ButtonSignIn-id", type: "submit" },
                          },
                          [_vm._v("\n              Done\n            ")]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "login-footer" }, [
      _c("img", {
        staticClass: "labs-logo login center-block",
        attrs: { src: "static/img/labs_logo.svg", alt: "labs-img" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }